import { FC } from 'react'
import styled from 'styled-components'
import { Check } from 'svgIcons'

interface IFCheckboxProps {
  checked?: boolean
  className?: string
}

const Checkbox: FC<IFCheckboxProps> = ({ checked = false, className }) => {
  return (
    <StyledWrapper data-checked={checked} className={className}>
      {checked && <Check />}
    </StyledWrapper>
  )
}

export default Checkbox

const StyledWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: 1px solid ${(props) => props.theme.line.line_2};
  border-radius: 5px;
  color: white;
  background-color: white;

  &[data-checked='true'] {
    background-color: ${(props) => props.theme.color.primary_2};
    border: 1px solid ${(props) => props.theme.color.primary_2};
  }

  > svg {
    width: 8px;
    height: 8px;
    fill: #fff;
  }
`
